import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) return null;
  if (!isAuthenticated) return <Navigate to="/login" />;

  return children;
}

export function RoleRoute({ allowedOrgRoles, children }) {
  const { isAuthenticated, organization, loading } = useAuth();

  if (loading) return null;
  if (!isAuthenticated) return <Navigate to="/login" />;
  if (!organization || !allowedOrgRoles.includes(organization.role)) {
    return <Navigate to="/unauthorized" />;
  }

  return children;
}
